"use client";
import * as S from "./styles.ts";
import ArrowDownRight from "@template/icons/ArrowDownRight.tsx";
import { H1, H4, IconHolder, UniversalLink } from "@template/components";

interface IAnchorLinksSectionProps {
  title?: string;
  links: { href: string; label: string }[];
}

const AnchorLinksSectionComponent = ({
  title,
  links,
}: IAnchorLinksSectionProps) => {
  return (
    <S.AnchorLinksSectionWrapper id="anchorMenu">
      <S.AnchorLinksSectionContainer>
        <H1 as="h2">{title}</H1>
        <S.LinksContainer>
          {links?.map((link, index) => (
            <UniversalLink
              href={link.href}
              key={index}
            >
              <S.LinkCard>
                <H4>{link.label}</H4>
                <S.IconSection>
                  <IconHolder color="primary">
                    <ArrowDownRight />
                  </IconHolder>
                </S.IconSection>
              </S.LinkCard>
            </UniversalLink>
          ))}
        </S.LinksContainer>
      </S.AnchorLinksSectionContainer>
    </S.AnchorLinksSectionWrapper>
  );
};

export default AnchorLinksSectionComponent;

export const options = [
  {
    description: "",
    displayName: "AnchorLinksSectionComponent",
    methods: [],
    props: {
      title: {
        required: false,
        flowType: { name: "string" },
        description: "",
      },
      links: {
        required: true,
        flowType: {
          name: "Array",
          elements: [
            {
              name: "signature",
              type: "object",
              raw: "{ href: string; label: string }",
              signature: {
                properties: [
                  {
                    key: "href",
                    value: {
                      name: "string",
                      required: true,
                    },
                  },
                  {
                    key: "label",
                    value: {
                      name: "string",
                      required: true,
                    },
                  },
                ],
              },
            },
          ],
          raw: "{ href: string; label: string }[]",
        },
        description: "",
      },
    },
  },
];
